import { ResponseErrors } from '@types';
import { auth, getLocale, modal, redirect } from '@utils';
import axios, { AxiosError } from 'axios';
import i18n from 'src/i18n';

const modalOptions = {
  '401': {
    title: i18n.t('unauthenticatedModal.title'),
    content: i18n.t('unauthenticatedModal.content'),
    action: i18n.t('unauthenticatedModal.action'),
    id: 'unauthenticated',
    onAction: auth.login
  },
  '403': {
    title: i18n.t('forbiddenModal.title'),
    content: i18n.t('forbiddenModal.content'),
    action: i18n.t('forbiddenModal.action'),
    id: 'forbidden',
    onAction: redirect.redirectToIBB
  },
  '510': {
    title: i18n.t('outsideBusinessHourTradingModal.title'),
    content: i18n.t('outsideBusinessHourTradingModal.content'),
    action: i18n.t('outsideBusinessHourTradingModal.action'),
    id: 'policy',
    onAction: redirect.redirectToIBB
  },
  '500': {
    title: i18n.t('systemNotAvailableModal.title'),
    content: i18n.t('systemNotAvailableModal.content'),
    action: i18n.t('systemNotAvailableModal.action'),
    id: 'serviceIsUnavailable',
    onAction: redirect.redirectToIBB
  }
};

const apiAxios = axios.create();

apiAxios.interceptors.response.use(
  (response) => response,
  async (error: AxiosError<ResponseErrors>) => {
    if (!error?.response?.status) {
      throw error.response;
    }

    const statusCode =
      error.response.status >= 500 && error.response.status !== 510
        ? '500'
        : error.response.status.toString();

    const modalOptionsKeys = Object.keys(modalOptions);

    if (!modalOptionsKeys.includes(statusCode)) {
      throw error.response;
    }

    const { title, content, id, action, onAction } =
      modalOptions[statusCode as keyof typeof modalOptions];
    const modalEl = modal(title, content, action, id, onAction, onAction);
    return modalEl.openModal();
  }
);

apiAxios.interceptors.request.use((config) => {
  const { lng } = getLocale();
  const newConfig = { ...config };
  if (newConfig.method === 'get') {
    newConfig.params = {
      ...config.params,
      language: lng.toUpperCase()
    };
  }

  return newConfig;
});

export default apiAxios;
